(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire423f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire423f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iTETw", function(module, exports) {
let check = document.querySelector(".toggle-mega-drawer");
let newMegaMenu = document.querySelector(".new-mega-menu");
if (!check) return;
function checkActiveDrawers(drawerId, back) {
    let activeDrawers = document.querySelectorAll(".drawer-active");
    if (activeDrawers.length == 0) {
        document.querySelectorAll(".menu-drawer__menu--without-submenu > .menu-drawer__menu-item").forEach((item)=>item.classList.remove("temp-hidden"));
        document.querySelectorAll(`.mega-menu-drawer .menu-drawer__menu-item`).forEach((item)=>item.classList.remove("temp-hidden"));
    } else {
        document.querySelectorAll(".menu-drawer__menu--without-submenu > .menu-drawer__menu-item").forEach((item)=>item.classList.add("temp-hidden"));
        document.querySelectorAll(`.mega-menu-drawer:not(#${drawerId}) > .menu-drawer__menu-item, .mega-menu-drawer:not(#${drawerId}) > .toggle-mega-drawer__link-back`).forEach((item)=>item.classList.add("temp-hidden"));
        document.querySelectorAll(`.mega-menu-drawer#${drawerId} > .menu-drawer__menu-item, .mega-menu-drawer#${drawerId} > .toggle-mega-drawer__link-back`).forEach((item)=>item.classList.remove("temp-hidden"));
        if (back) {
            let tempDrawerId = drawerId.replace(/-[^-]*$/, "");
            document.querySelectorAll(`.mega-menu-drawer#${tempDrawerId} > .menu-drawer__menu-item, .mega-menu-drawer#${tempDrawerId} > .toggle-mega-drawer__link-back`).forEach((item)=>item.classList.remove("temp-hidden"));
        }
    }
}
document.addEventListener("click", function(e) {
    let target = e.target;
    let back = false;
    if (target.classList.contains("toggle-mega-drawer")) {
        let drawerId = target.dataset.drawerId;
        document.querySelector(`#${drawerId}`).classList.toggle("drawer-active");
        if (target.classList.contains("toggle-mega-drawer__link-back")) back = true;
        checkActiveDrawers(drawerId, back);
    }
});
if (!newMegaMenu) document.querySelectorAll('header-menu [id^="Details-"] summary').forEach((summary)=>{
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
    if (summary.nextElementSibling.getAttribute("id")) summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    summary.addEventListener("mouseenter", (event)=>{
        event.target.setAttribute("aria-expanded", !event.target.closest("details").hasAttribute("open"));
        event.target.closest("details").setAttribute("open", "open");
    });
    summary.closest(".mega-menu").addEventListener("mouseleave", (event)=>{
        event.target.closest("details").removeAttribute("open");
    });
});
else {
    document.querySelectorAll("ul.list-menu li").forEach((summary)=>{
        const allSiblings = document.querySelectorAll('[id^="MegaMenu-Content-"]');
        const stickyHeader = document.querySelector("sticky-header");
        summary.addEventListener("mouseenter", (event)=>{
            if (summary.querySelector('[id^="Details-HeaderMenu-"]')) {
                const siblingIdArray = summary.querySelector('[id^="Details-HeaderMenu-"]').id;
                const siblingId = "MegaMenu-Content-" + siblingIdArray[siblingIdArray.length - 1];
                allSiblings.forEach((element)=>{
                    element.style.display = "none";
                });
                document.getElementById(siblingId).style.display = "flex";
                stickyHeader.classList.remove("floating-header");
            } else {
                allSiblings.forEach((element)=>{
                    element.style.display = "none";
                });
                stickyHeader.classList.add("floating-header");
            }
        });
        summary.closest(".header-wrapper").addEventListener("mouseleave", (event)=>{
            stickyHeader.classList.add("floating-header");
            allSiblings.forEach((element)=>{
                element.style.display = "none";
            });
            stickyHeader.classList.add("floating-header");
        });
    });
    document.getElementById("cart-icon-bubble-new").addEventListener("click", function(e) {
        e.preventDefault();
        document.getElementById("cart-icon-bubble").click();
    });
}

});

if (!customElements.get("country-overlay-form")) customElements.define("country-overlay-form", class CountryOverlayForm extends HTMLElement {
    constructor(){
        super();
        this.elements = {
            closeInput: this.querySelector(".country-overlay-form__inner--close-btn"),
            input: this.querySelector('input[name="country_code"]'),
            langInput: this.querySelector('input[name="locale_code"]'),
            currMarket: document.querySelector("html").getAttribute("market"),
            restOfWorldInput: this.querySelector(".rest-of-world__placeholder")
        };
        this.elements.closeInput.addEventListener("click", (e)=>this.closeOverlay(e));
        this.addEventListener("click", (e)=>this.closeOverlay(e));
        if (this.elements.restOfWorldInput) this.elements.restOfWorldInput.addEventListener("click", (e)=>this.closeOverlay(e, true));
        this.querySelectorAll("a.disclosure__link").forEach((item)=>item.addEventListener("click", this.onItemClick.bind(this)));
        if (this.elements.currMarket === "xk" && localStorage.getItem("witt-market-popup-shown") === null || this.elements.currMarket === "xk" && localStorage.getItem("witt-market-popup-shown") === null) this.openOverlay();
    }
    closeOverlay(e, closeAutomatically) {
        if (e.target.classList.contains("country-overlay-form__inner--close-btn") || e.target === this || closeAutomatically) {
            this.classList.add("hidden");
            document.querySelector("html").classList.remove("no-scroll");
            localStorage.setItem("witt-market-popup-shown", true);
            localStorage.setItem("witt-market-locale", "");
        }
    }
    setMarketPopupCookies(name, value, minutes) {
        return document.cookie = `${name}=${value}; max-age=${minutes * 60}; path=/`;
    }
    getCookie(name) {
        return document.cookie?.split("; ").find((row)=>row.startsWith(name))?.split("=")[1];
    }
    openOverlay() {
        this.removeSpecificCountriesFromOverlay();
        this.classList.remove("hidden");
        document.querySelector("html").classList.add("no-scroll");
    }
    removeSpecificCountriesFromOverlay() {
        const kosovoEl = this.querySelector('a[data-value="XK"]');
        if (kosovoEl) kosovoEl.remove();
    }
    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.langInput.value = event.currentTarget.dataset.lang;
        this.elements.input.value = event.currentTarget.dataset.value;
        localStorage.setItem("witt-market-popup-shown", true);
        localStorage.setItem("witt-market-locale", `${event.currentTarget.dataset.lang}-${event.currentTarget.dataset.value}`);
        if (form) form.submit();
    }
});


parcelRequire("iTETw");

})();
//# sourceMappingURL=parcel_scripts.js.map
